import React from 'react';
import { Route, RouteProps, RouteComponentProps } from 'react-router-dom';
import { useAppUser } from '../providers/AppUserProvider';
import { PermissionType } from 'Services/permissions/interfaces';

export interface ProtectedRouteProps extends Omit<RouteProps, 'render'|'component'|'children'> {
  requiredPermissions?: PermissionType[] | PermissionType[][];
  // TODO: Remove forbiddenPermissions field once we remove old-reports page
  forbiddenPermissions?: PermissionType[];
  render: ( props: RouteComponentProps<any>, hasAccess: boolean ) => React.ReactNode;
}

export const ProtectedRoute: React.FC<ProtectedRouteProps> = ( {
  requiredPermissions = [],
  forbiddenPermissions,
  render,
  ...routeProps
} ) => {
  const user = useAppUser();
  const hasAccess = React.useMemo<boolean>( () => {
    return user.hasPermissions( requiredPermissions, forbiddenPermissions );
  }, [ requiredPermissions, forbiddenPermissions, user ] );


  return (
    <Route { ...routeProps } render={ ( props ) => render( props, hasAccess ) } />
  );
};
